import t from "./ghl-ui.es760.js";
import e from "./ghl-ui.es745.js";
var s = "[object Arguments]";
function m(r) {
  return e(r) && t(r) == s;
}
export {
  m as default
};
